import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Button } from "@progress/kendo-react-buttons";
import { BaasicFieldDropdown, BasicInput, BaasicModal } from 'core/components';
import { FacilityOrderNewFlowConfirmModal } from "application/facility-order-new-flow/components";

function PatientInformationBarNewFlowTemplate({ patientInformationBarNewFlowViewStore, disabled }) {
    const {
        isStatusBarVisible,
        isEditMode,
        changeMenuVisibility,
        changeEditMode,
        form,
        genderStore,
        facilityOrderNewFlowConfirmModal,
        openFacilityOrderNewFlowConfirmModal,
        goToBT,
        role,
        isNewPatient,
        patient,
        isMasterPatient,
        isEditOptionDisabled
    } = patientInformationBarNewFlowViewStore;
    return (
        <div>
            {
                isStatusBarVisible ?
                    <div className="patient__bar is-grey u-mar--left--tny">
                        <ReactTooltip positionStrategy="fixed" id={"patientInformationTip" + patient.id} place="top" />
                        {(role === "US Intake" || role === "US Intake Single" || role === "Clinical") && <Button className="btn is-expand is-bar" icon="u-icon u-icon--xmed u-icon--patient-back" onClick={() => changeMenuVisibility()} data-tooltip-content="Hide patient info" data-tooltip-id={"patientInformationTip" + patient.id} />}
                        <div className='patient__group'>
                            <div>
                                <i onClick={() => goToBT()} className={`u-icon u-icon--lrg u-mar--right--tny u-icon--insurance-external-link${isEditMode && !disabled ? `--grey` : ``}`} />
                                <span className={`patient__brighttree ${isEditMode && !disabled ? `is-grey` : ``}`}>{patient.patientId}</span>
                            </div>
                            <span className='patient__group__divider'>|</span>
                            {isEditMode && !disabled ? <div className='u-flex--primary u-flex--no-wrap u-flex--gap--1-5'> <i className='u-icon u-icon--lrg u-icon--patient-name'></i><div className="patient__name"><BasicInput field={form.$('lastName')} /></div><div className="patient__name"><BasicInput field={form.$('firstName')} /></div><span className='patient__group__divider'>|</span></div> : null}
                            {isEditMode && !disabled ? <React.Fragment><div className='u-flex--primary u-flex--no-wrap'><i className='u-icon u-icon--lrg u-icon--patient-user u-mar--right--tny'></i> <BaasicFieldDropdown field={form.$('gender')} store={genderStore} />
                            </div> <span className='patient__group__divider'>|</span></React.Fragment> :
                                <React.Fragment><div className='u-flex--primary u-flex--no-wrap'><i className='u-icon u-icon--lrg u-icon--patient-user u-mar--right--tny'></i><span>{form.$('gender').value}</span></div><span className='patient__group__divider'>|</span></React.Fragment>
                            }
                            {isEditMode && !disabled ? <React.Fragment><div className='u-flex--primary u-flex--no-wrap'><i className='u-icon u-icon--lrg u-icon--patient-ssn u-mar--right--tny'></i> <BasicInput field={form.$('ssn')} /></div><span className='patient__group__divider'>|</span></React.Fragment> :
                                <React.Fragment><div className='u-flex--primary u-flex--no-wrap'><i className='u-icon u-icon--lrg u-icon--patient-ssn u-mar--right--tny'></i><span>{form.$('ssn').value}</span> </div><span className='patient__group__divider'>|</span></React.Fragment>
                            }
                            {isEditMode && !disabled ? <React.Fragment><div className='u-flex--primary u-flex--no-wrap'><i className='u-icon u-icon--lrg u-icon--patient-camera u-mar--right--tny'></i> <BasicInput field={form.$('dateOfBirth')} /></div></React.Fragment> :
                                <div className='u-flex--primary u-flex--no-wrap'><i className='u-icon u-icon--lrg u-icon--patient-camera u-mar--right--tny'></i><span>{form.$('dateOfBirth').value}</span></div>
                            }

                        </div>
                        {disabled ?
                            <React.Fragment></React.Fragment>
                            :
                            isEditMode ?
                                <div className="u-flex--primary u-flex--no-wrap u-flex--gap--1-5">
                                    <Button className="btn btn--patient ex-hover" icon="u-icon u-icon--lrg u-icon--patient-check" onClick={async () => await openFacilityOrderNewFlowConfirmModal()} />
                                    <Button className="btn btn--patient ex-hover" icon="u-icon u-icon--lrg u-icon--patient-close" onClick={() => changeEditMode(true)} />
                                </div>
                                :
                                !isMasterPatient && ((role === "US Intake" || role === "US Intake Single" || role === "Clinical") || ((role === "Initial Intake" || role === "Insurance") && isNewPatient)) ?
                                    <Button className="btn is-expand" icon="u-icon u-icon--med u-icon--edit-alt--primary" onClick={() => changeEditMode()} data-tooltip-content="Edit" data-tooltip-id={"patientInformationTip" + patient.id} disabled={role !== "US Intake Single" && isEditOptionDisabled} /> : null
                        }
                    </div>
                    :
                    <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id={"patientInformationTip" + patient.id} place="top" />
                        <Button className="btn is-expand u-mar--left--sml is-bar" icon="u-icon u-icon--xmed u-icon--patient-forward" onClick={() => changeMenuVisibility()} data-tooltip-content="View patient info" data-tooltip-id={"patientInformationTip" + patient.id} />
                    </React.Fragment>
            }
            <BaasicModal modalParams={facilityOrderNewFlowConfirmModal} className="modal__content modal--sml">
                <FacilityOrderNewFlowConfirmModal />
            </BaasicModal>
        </div>
    )
}

PatientInformationBarNewFlowTemplate.propTypes = {
    patientInformationBarNewFlowViewStore: PropTypes.object,
    disabled: PropTypes.bool,
    t: PropTypes.func
};

export default defaultTemplate(PatientInformationBarNewFlowTemplate);
